import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class AnimationDirection extends BaseOption {
  static userInterfaceComponent = {
    label: "Direction",
    component: inspectorTools.SIMPLE_PICKER,
    canSetOtherStates: [],
    props: {
      options: [
        {
          name: "Normal",
          id: "normal",
        },
        {
          name: "Reverse",
          id: "reverse",
        },
        {
          name: "Alternate",
          id: "alternate",
        },
        {
          name: "Alternate Reverse",
          id: "alternate-reverse",
        },
      ],
    },
  };

  static defaultValue = "normal";
}
